module.exports = __webpack_public_path__ + "static/img/rule.1acc3c93.jpg";